<template>
  <div class="user">
    <div class="pb50">
      <!--内容-->
      <div class="product-content">
        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">结算单号：</span>
                {{ detail.settlement_no }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">结算月份：</span>
                {{ detail.month }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">月度总销量：</span>
                {{ detail.product_num }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">月度总销售额：</span>
                {{ detail.product_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">总奖励：</span>
                {{ detail.total_award }} 元
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">总人数：</span>
                {{ detail.total_user }}
              </div>
            </el-col>
             <el-col :span="5">
              <div class="pb16" v-if="detail.grade">
                <span class="gray9">等级：</span>
                {{ detail.grade.name }}
              </div>
            </el-col>
             <el-col :span="5">
              <div class="pb16">
                <span class="gray9">状态：</span>
                 <span class="gray" v-if="detail.status == 0">待确认</span>
                <span class="green" v-if="detail.status == 1">已发放</span>
              </div>
            </el-col>
             <el-col :span="5">
              <div class="pb16">
                <span class="gray9">分红类型：</span>
                 <span class="red" v-if="detail.bonus_type == 1">平均分红</span>
                <span class="blue" v-if="detail.bonus_type == 2">业绩加权分红</span>
              </div>
            </el-col>
            <el-col :span="5" v-if="detail['status'] == 0" >
              <el-button @click="confirmClick(detail, 'edit')" size="small">确认结算单</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">

        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.keyword" placeholder="请输入会员ID查询"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="nickName" label="会员">
               <template slot-scope="scope">
                <div class="d-s-c">
                  <img v-img-url="scope.row.user.avatarUrl" width="60px" height="60px" />
                  <div class="ml10">
                    <p class="f14 fb">{{ scope.row.user.nickName }}</p>
                    <p class="gray3" v-if="scope.row.user.mobile">手机：{{ scope.row.user.mobile }}</p>
                    <p class="gray9">用户ID：{{ scope.row.user.user_id }}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="product_num" label="实际团队销量"></el-table-column>
            <el-table-column prop="product_price" label="实际团队销售额"></el-table-column>
            <el-table-column prop="award_rate" label="奖励比例">
              <template slot-scope="scope">
                  <div class="d-s-c">{{scope.row.award_rate}}%</div>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="分红(元）" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
      <!--操作-->
      <div class="common-button-wrapper">
        <el-button size="small" @click="cancelFunc">返回</el-button>
      
      </div>
    </div>
  </div>
</template>

<script>
  import BonusdApi from '@/api/weightbonus.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {
          id: 0,
          keyword: ''
        },
        detail: [],
        status: ['未开始', '进行中', '已结束'],
        file:{},
      };
    },
    created() {
      this.formInline.settlement_id = this.$route.query.settlement_id;
      /*获取结算单*/
      this.getSettlement();
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      getSettlement(){
        let self = this;
        let settlement_id = self.formInline.settlement_id;
        BonusdApi.getSettlement({settlement_id:settlement_id}, true)
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        BonusdApi.getSettlementLogList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

      confirmClick(){
        let self = this;
        let settlement_id = self.formInline.settlement_id;
        self.$confirm('此操作将直接发放奖励, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          BonusdApi.sendSettlement({settlement_id:settlement_id}, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '结算单已确认，请结算奖励',
                type: 'success'
              });
              self.getSettlement();
            })
            .catch(error => {
              self.loading = false;
            });
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消'
          });          
        });
        
      },

      sendClick(){
        let self = this;
        let id = self.formInline.id;
        self.loading = true;
        BonusdApi.sendSettlement({id:id}, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '收益已发放成功！',
              type: 'success'
            });
            self.getSettlement();
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
      /*取消*/
      cancelFunc() {
        /*存储缓存*/
        localStorage.setItem('activeName','second')
        this.$router.back(-1);
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/weightbonus/bonus/detail.vue